import {apiGet} from "@/services/api";

export const SeoService = {
    getSeo(url: string): Promise<{TITLE: string, DESCRIPTION: string} | []> {
        return apiGet('seo/', {
            url
        })
    }
}